import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PortalShell from '../components/PortalShell';
import ResponsiveTable from '../components/ui/ResponsiveTable';
import { Globals } from '../globalfunctions.js';
import { apiClient } from '../utils/apiClient';
import { formatMoney } from '../utils/currency';

const CYCLE_LABELS = { monthly: 'Monthly', quarterly: 'Quarterly', annually: 'Annually' };

function PortalSubscriptions() {
  const navigate = useNavigate();
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (Globals.LoginTime === null) {
      localStorage.setItem('redirectAfterLogin', window.location.pathname);
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    (async () => {
      try {
        setSubscriptions(await apiClient.get('/api/subscriptions/mine'));
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const columns = [
    { key: 'description', label: 'Service', sortable: true },
    {
      key: 'recurring_amount',
      label: 'Amount',
      sortable: true,
      render: (row) => formatMoney(row.recurring_amount, row.currency)
    },
    { key: 'billing_cycle', label: 'Billed', render: (row) => CYCLE_LABELS[row.billing_cycle] || row.billing_cycle },
    {
      key: 'next_due_date',
      label: 'Next Invoice',
      sortable: true,
      render: (row) => row.next_due_date ? new Date(row.next_due_date).toLocaleDateString() : '—'
    },
    { key: 'status', label: 'Status' }
  ];

  return (
    <PortalShell>
      <h1>Subscriptions</h1>
      {loading ? (
        <p>Loading your subscriptions...</p>
      ) : (
        <ResponsiveTable columns={columns} rows={subscriptions} rowKey="id" emptyMessage="You don't have any recurring services." />
      )}
    </PortalShell>
  );
}

export default PortalSubscriptions;
